import { render, staticRenderFns } from "./SimpleSecurity.vue?vue&type=template&id=3b64f23a&"
import script from "./SimpleSecurity.vue?vue&type=script&lang=js&"
export * from "./SimpleSecurity.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports